import styled from "styled-components";

const LowerButton = styled.button`
  background: #f7f7f7;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  color: #828282;
  padding: 8px;
`;

export default LowerButton;
